import {Component, inject} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {ActivatedRoute, Router} from '@angular/router';
import {LucideAngularModule, ShieldCheckIcon} from 'lucide-angular';
import {BrowserService} from '@core/service/browser.service';
import {RouteGenerator} from '@core/route-generator';
import {LoginComponent} from '@domain/common/component/login/login.component';
import {
  ActivityPublishRulesComponent
} from '@domain/activity/component/activity-publish-rules/activity-publish-rules.component';
import {UI_ROUTES} from '@core/ui.routes';
import {AuthService} from '@core/auth/auth.service';

@Component({
  selector: 'app-guest-publish-activity',
  imports: [
    TranslocoDirective,
    LoginComponent,
    LucideAngularModule,
    ActivityPublishRulesComponent
  ],
  templateUrl: './publish-activity.component.html',
  styleUrl: './publish-activity.component.scss'
})
export class PublishActivityComponent {

  private readonly route = inject(ActivatedRoute);
  private readonly browserService = inject(BrowserService);

  public readonly icons = {
    check: ShieldCheckIcon
  };

  public readonly routes = {
    publish: RouteGenerator.abs(UI_ROUTES.account.activity.create),
    terms: RouteGenerator.abs(UI_ROUTES.public.terms.home)
  };

  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  public constructor() {
    const invitationId = this.route.snapshot.queryParams?.invitation as string ?? null;
    if (invitationId) {
      this.browserService.write(BrowserService.STORAGE_KEY.Invitation, invitationId);
    }
    const user = this.authService.getAuthenticatedUser();
    if (user) {
      this.router.navigate([this.routes.publish])
        .then(_ok =>  {});
    }
  }
}
